import AvatarPlaceholder from '../../../assets/svg/utils/avatar-place-holder.svg';
import Coin from '../../../assets/svg/utils/coins/coin-ltr.svg';
import { ReferralT } from '../../../store/reducers/referrals/types';
import { formatNumbers } from '../../../helpers';

type FriendsCardProps = {
  referral: ReferralT
}
function FriendCard({ referral }: FriendsCardProps) {
  return (
    <div className="grid grid-cols-[1fr_auto] gap-[6px] bg-black-light-bg p-3 pt-[.4rem] rounded-10 w-full max-h-[100px]">
      <img src={AvatarPlaceholder} alt="avatar" className="rounded max-w-[18px] max-h-[18px] h-fit" />
      <div className="text-start text-gray-300 text-sm">
        Total profit
      </div>
      <div className="text-base text-start font-bold line-normal text-ellipsis whitespace-nowrap truncate ">
        {referral.username}
      </div>
      <div className="text-base flex items-center gap-[1px] pr-1 mt-[-.15rem] line-normal font-bold">
        <span className="pr-1">
          {formatNumbers(referral.coins || 0, 3, false)}
        </span>
        <img src={Coin} alt="coin-icon" className="w-[18px]" />
      </div>
    </div>
  );
}

export default FriendCard;
